import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Componente que hace scroll al top cada vez que cambia la ruta.
 * Se monta una sola vez en App.tsx y funciona globalmente.
 */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // No hacer scroll en la página de productos
    if (pathname === "/products") {
      return;
    }

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, [pathname]);

  return null;
}
